import { characterKnows, getCharacter, secretsForView } from "../domain/engine";
import { Sources, StatusBadge } from "../components/ui";
import { useStore } from "../store";

export function Secrets() {
  const { bible, selection } = useStore();
  if (!bible) return null;
  const rows = secretsForView(bible, selection.momentId, selection.viewer);
  return (
    <div>
      <h1>Secrets et connaissances</h1>
      <p className="tiny">
        Trois niveaux : vérité objective, connaissance des personnages, révélation au lecteur.
        {selection.viewer === "reader" && selection.momentId
          ? " Vue lecteur : les secrets non révélés restent masqués."
          : " Vue auteur : le caché est visible, mais marqué comme tel."}
      </p>
      <div className="grid">
        {rows.map(({ secret, objectivelyTrue, readerKnows, hiddenFromReader }) => {
          if (selection.viewer === "reader" && selection.momentId && !readerKnows) {
            return (
              <article key={secret.id} className="card secret-card">
                <h3>{secret.title}</h3>
                <p className="hidden-tag">Non révélé au lecteur à cet instant.</p>
              </article>
            );
          }
          return (
            <article key={secret.id} className="card secret-card">
              <div className="row space">
                <h3>{secret.title}</h3>
                <StatusBadge status={secret.status} />
              </div>
              <p>{secret.objectiveTruth}</p>
              <p className="tiny">
                Vrai depuis {secret.trueFromMomentId}
                {objectivelyTrue || !selection.momentId ? " · objectivement vrai ici" : " · pas encore vrai"}
                {" · "}
                {readerKnows ? "lecteur informé" : "lecteur non informé"}
                {hiddenFromReader ? " · encore secret dans le récit" : ""}
              </p>
              <h4>Qui sait ?</h4>
              {secret.knownBy.length === 0 && <p className="tiny">Aucun personnage n’a de connaissance structurée (ex. S.A.B.E.R.).</p>}
              {secret.knownBy.map((k) => {
                const known = !selection.momentId || characterKnows(bible, secret, k.characterId, selection.momentId);
                const name = getCharacter(bible, k.characterId)?.name ?? k.characterId;
                return (
                  <p key={k.characterId + k.knownFromMomentId} className="tiny">
                    {name} : {k.certainty} depuis {k.knownFromMomentId}
                    {known ? "" : " — pas encore à cet instant"}
                    {k.believedVersion ? ` · croit : ${k.believedVersion}` : ""}
                  </p>
                );
              })}
              <Sources sources={secret.sources} />
            </article>
          );
        })}
      </div>
    </div>
  );
}
